import { Alert, Box, CircularProgress, FormControl, InputLabel, Modal, Snackbar } from "@mui/material";
import { format, parse } from "date-fns";
import { useEffect, useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";

import { style as modalStyle } from "../../../components/Loading/Loading";
import { ptBR } from "date-fns/locale";
import { WhiteInput } from "../../../components/Inputs/InputText";
import styles from "./ResultadoAnalise.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClose, faPen } from "@fortawesome/free-solid-svg-icons";

const ResultadoAnalise = ({ setOpen, record }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [situacaoTexto, setSituacaoTexto] = useState("");

    useEffect(() => {
        if (record === null) {
            return;
        }

        let txtSituacao = "";
        
        switch (record?.Situacao) {
            case 1:
                txtSituacao = "Aguardando análise"
                break;
            case 2:
                txtSituacao = "Finalizada"
                break;
            case 3:
                txtSituacao = "Reprovada"
                break;
            default:
                break;
        }

        setSituacaoTexto(txtSituacao);
    }, [record]);

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    return (
        <div style={{ width: "100%", minWidth: 600, height: "100%" }}>
            { (record !== null && record?.Id !== 0) && (
                <div>
                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={styles.dateBox}></div><b>Data de apresentação: </b> {
                                record?.DataApresentacao?.includes("01/01/1900") ?
                                    "Data ainda não definida" :
                                    format(parse(record?.DataApresentacao, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                        locale: ptBR
                                    })
                            }
                        </span>
                    </header>

                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={`${styles.dateBox} ${styles['dateBox-orange']}`}></div><b>Data de prazo da análise: </b> {
                                record?.DataPrazo?.includes("01/01/1900") ?
                                    "Data ainda não definida" :
                                    format(parse(record?.DataPrazo, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                        locale: ptBR
                                    })
                            }
                        </span>
                    </header>

                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={`${styles.dateBox} ${styles['dateBox-green']}`}></div><b>Data de análise: </b>{
                                record?.DataAnalise?.includes("01/01/1900") ?
                                    "Data ainda não definida" :
                                    format(parse(record?.DataAnalise, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                        locale: ptBR
                                    })
                            }
                        </span>
                    </header>
                </div>
            )}
            
            <div className={styles.situacaoAnalise}>
                <div className={
                        record?.Situacao === 1
                        ? `${styles.resultadoAnaliseParcial} + ${styles.AguardandoAnalise}`
                        : record?.Situacao === 2
                        ? `${styles.resultadoAnaliseParcial} + ${styles.Finalizada}` 
                        : `${styles.resultadoAnaliseParcial} + ${styles.Reprovada}`
                }>
                    <h3>Resultado</h3>
                    <div className={styles.parecerSituacao}>
                        Situação:  {
                            situacaoTexto
                        }    
                        <p><FontAwesomeIcon 
                            size="lg"
                            icon={
                                record?.Situacao === 1
                                ? faPen
                                : record?.Situacao === 2
                                ? faCheck
                                : faClose
                            }
                            />
                        </p>
                    </div>
                </div>
            
                <div className={styles.descricao}>
                    <strong style={{ display: "block" }}>Parecer da análise:</strong>
                    <FormControl variant="outlined" style={{ width: "100%" }}>
                        <WhiteInput 
                            style={{ color: "#B8B8B8" }}
                            fullWidth
                            type="text"
                            minRows={4}
                            multiline
                            value={record?.ParecerAnalise}
                            readOnly={true}
                        />
                    </FormControl>
                </div>
            </div>

            <div style={{
                margin: "25px 40px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px"
            }}>
                <BlueHoverButton onClick={() => setOpen(false)}>Fechar</BlueHoverButton>
            </div>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { ResultadoAnalise }